import React from "react";
import VideoSection from "./VideoSection";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// Images
import Car from "./Car.png";
import marketplace from "./exx1.png";
import inventory from "./Exx4.png";
import ownership from "./buying.png";
import buying from "./exx12.png";
import proof from "./proof1.png";
import exx1 from "./exx2.png";
import exx3 from "./inventory.png";
import exx4 from "./exx5.png";
import exx5 from "./exx6.png";
import exx6 from "./exx8.png";
import exx7 from "./exx9.png";
import rev4 from "./rev4.png";

// Vehicle images for the ROI carousel
import back1 from "./ex1.png";
import back2 from "./ex2.png";
import back3 from "./ex3.png";
import ex4 from "./ex4.png";
import ex5 from "./ex5.png";

// Placeholder arrays for other carousel images; replace with actual image URLs or imports.
const carouselImages1 = [
  "path/to/image1.jpg",
  "path/to/image2.jpg",
  "path/to/image3.jpg"
];
const carouselImages2 = [
  "path/to/image4.jpg",
  "path/to/image5.jpg",
  "path/to/image6.jpg"
];

// Define vehicle slides for the ROI carousel using back1, back2, back3 images
const vehicleSlides = [
  { src: back1, title: "Vehicle 1", roi: "ROI: 15% annually" },
  { src: back2, title: "Vehicle 2", roi: "ROI: 18% annually" },
  { src: back3, title: "Vehicle 3", roi: "ROI: 22% annually" }
];

// Simulated random vehicles for the marketplace carousel
const randomVehicles = [
  { id: 1, image: back1, title: "", description: "Great ROI and performance." },
  { id: 2, image: back2, title: "", description: "High demand and appreciation." },
  { id: 3, image: back3, title: "", description: "Rare and valuable" },
  { id: 4, image: ex4, title: "", description: "Exceptional rental income." },
  { id: 5, image: ex5, title: "", description: "Steady returns and growth." }
];

const HowItWorksPage = () => {
  return (
    <div style={{ fontFamily: "Roboto, sans-serif", color: "#151616", padding: "20px" }}>
      {/* Hero Section */}
      <section
        style={{
          textAlign: "center",
          padding: "60px 20px",
          backgroundColor: "#f7f7f7",
          borderRadius: "10px",
          marginBottom: "40px"
        }}
      >
        <h1 style={{ fontSize: "4rem", color: "#007bff", margin: "0 0 20px" }}>
          Step-by-Step: How Gier Works
        </h1>
        {/* Insert VideoSection here */}
        <VideoSection />
        <p style={{ fontSize: "2rem", fontWeight: "bold", margin: "40px 0" }}>
          Using AI to turn Vehicles Into Assets
        </p>
        <img src={Car} alt="Car" style={{ width: "50%", maxWidth: "500px" }} />
      </section>

      {/* Steps Section */}
      <section style={{ marginBottom: "40px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* Step 1 */}
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "200px", textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}>1. Browse The Marketplace</h3>
              <p style={{ fontSize: "1.2rem" }}>
                Explore a wide variety of vehicles categorized by type, ROI, location, and performance history. <br/>
                Using AI to analyze the vehicle, investment potential, and historical data, we only list the best vehicles.
                <br/><br/>
                All investment vehicles are hand-picked for maximum profit potential. 
              </p>
            </div>
            <div style={{ flex: "1", minWidth: "300px", textAlign: "center" }}>
              <img src={marketplace} alt="Marketplace" style={{ width: "80%", borderRadius: "10px" }} />
            </div>
          </div>

          {/* Step 2 */}
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
              <img src={buying} alt="Investing" style={{ width: "80%", borderRadius: "10px" }} />
            </div>
            <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}> Vehicle Information </h3>
              <p style={{ fontSize: "1.2rem" }}>
                The top will show the make, model and year of the vehicle plus any tags. <br/>
                The allocation percentage will be right under the image followed by the total value of the vehicle.<br/> 
<br/>  The payout and ownership shows you how much you own and <br/> how much the car has paid out in the past. <br/> <br/>   Click the invest button to show more details about the car.


              </p>
            </div>
          </div>


{/* Step 2 */}
<div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
  <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
    <img src={rev4} alt="Investing" style={{ width: "60%", borderRadius: "10px" }} />
  </div>
  <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
    <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}>Vehicle Tags</h3>
    <div style={{ fontSize: "1.2rem", textAlign: "center" }}>
      <p>
        <strong style={{ color: "#42D010" }}>Cash Flow:</strong> This means the vehicle is strong at generating income.
      </p>
      <p>
        <strong style={{ color: "#B400FF" }}>Rare:</strong> This tag highlights the vehicle's scarcity and potential for appreciation.
      </p>
      <p>
        <strong style={{ color: "orange" }}>Limited:</strong> Being labeled Limited indicates the car is from a small production or extremely hard to find.
      </p>
      <p>
        <strong style={{ color: "#00c9ff" }}>One of One:</strong> This signifies a truly unique vehicle. The rarest of them all.
      </p>
      <p>
       
      </p>
    </div>
  </div>
</div>



          {/* Step 3 */}
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}> 2. Find Your Investment Vehicle</h3>
              <p style={{ fontSize: "1.2rem" }}>
                The vehicle details page shows you all the information you need about the vehicle. <br/> <br/> Below the progress bar will show the full amount of money alloted to that vehicle
              <br/><br/> Explore recent payouts of the vehicle, other investors, predicted ROI and location details. 
              
              </p>
            </div>
            <div style={{ flex: "1", minWidth: "300px", textAlign: "center" }}>
              <img src={inventory} alt="Earnings" style={{ width: "80%", borderRadius: "10px" }} />
            </div>
          </div>

           {/* Step 3 */}
           <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}> 3. Press Invest To Buy Shares</h3>
              <p style={{ fontSize: "1.2rem" }}>
                You can buy ownership of the vehicle. It will show the ownership, freedays and rental discounts.  <br/> <br/>
                 Some cars will have minimums.
              <br/><br/>
              
              </p>
            </div>
            <div style={{ flex: "1", minWidth: "300px", textAlign: "center" }}>
              <img src={ownership} alt="Earnings" style={{ width: "80%", borderRadius: "10px" }} />
            </div>
          </div>

          {/* Step 4 */}
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
              <img src={exx1} alt="Ownership" style={{ width: "60%", borderRadius: "10px" }} />
            </div>
            <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}>Fully Allocated Vehicles</h3>
              <p style={{ fontSize: "1.2rem" }}>
                When there is no more equity avaliable to buy the progress bar will turn blue. <br/>
                The invest button will also now say details and a rent button will show up.
              </p>
            </div>
          </div>

 {/* Step 4 */}
 <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
              <img src={exx3} alt="Ownership" style={{ width: "60%", borderRadius: "10px" }} />
            </div>
            <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}>Step 4. Track Your Shares. Earn Dividends.</h3>
              <p style={{ fontSize: "1.2rem" }}>
                After you purchase ownership in a investment vehicle it will show up on your <br/> profile page and investments Page.
<br/> <br/> Your portfolio will show the total value, average roi, and revenue <br/> your vehicles are generating. Done!

              </p>
            </div>
          </div>

          {/* Step 4 */}
 <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
              <img src={exx4} alt="Ownership" style={{ width: "60%", borderRadius: "10px" }} />
            </div>
            <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}>Creating New Investment Vehicle Listings</h3>
              <p style={{ fontSize: "1.2rem" }}>
                Don't see a vehicle you like? We can get it for you. <br/> Click the create listing button.
<br/> <br/>

              </p>
            </div>
          </div>

 {/* Step 4 */}
 <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
              <img src={exx5} alt="Ownership" style={{ width: "60%", borderRadius: "10px" }} />
            </div>
            <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}>5. Submit the form! </h3>
              <p style={{ fontSize: "1.2rem" }}>
                New vehicle listings require 10% of the downpayment of the total investment price. <br/>You must also be approved.
                <br/> <br/>
                 Tell us about the vehicle you want. 
<br/> <br/> You can also list your personal vehicle to make extra revenue. We will manage everything for you. 

              </p>
            </div>
          </div>




          
 {/* Step 4 */}
 <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
              <img src={exx6} alt="Ownership" style={{ width: "60%", borderRadius: "10px" }} />
            </div>
            <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
              <h3 style={{ fontSize: "2.7rem", marginBottom: "10px" }}>Bigger Investments </h3>
              <p style={{ fontSize: "1.2rem" }}>
                For bigger Investments over $500,000 please fill out the form. <br/> We will find around 15-25 vehicles for you that are hand-picked  using AI for the highest returns. 
                <br/> <br/>
                 Want to Invest with friends? Invite 5 other friends to join you.
<br/> <br/>  

              </p>
            </div>
          </div>




          
 {/* Step 4 */}
 <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
            <div style={{ flex: "1", minWidth: "300px", order: 2, textAlign: "center" }}>
              <img src={exx7} alt="Ownership" style={{ width: "60%", borderRadius: "10px" }} />
            </div>
            <div style={{ flex: "1", minWidth: "300px", order: 1, textAlign: "center" }}>
              <h3 style={{ fontSize: "2.5rem", marginBottom: "10px" }}> Check Your Listing Requests </h3>
              <p style={{ fontSize: "1.2rem" }}>
                You can check all listing requests by using the hamburger settings menu on the top right of the app.
                <br/> <br/>
                 When approved your investment vehicle will show up on the marketplace and on your profile! 
<br/> <br/>

              </p>
            </div>
          </div>




        </div>
      </section>

      

      {/* Why Cars Section */}
      <section style={{ marginBottom: "40px", textAlign: "center", marginTop: "100px" }}>
        <h2 style={{ fontSize: "2.5rem", color: "#007bff", marginBottom: "20px" }}>Why Cars Are A Winning Investment</h2>
        <p style={{ fontSize: "2rem", marginBottom: "20px" }}>
          Cars have proven to be a lucrative investment over the years. Here's why:
        </p>
        <ul style={{ listStyle: "none", padding: "0", fontSize: "1.5rem", color: "black", textAlign: "center", display: "inline-block" }}>
          <li style={{ marginBottom: "10px" }}>
            <strong>Historical Performance:</strong> Rare vehicles appreciated by an average of 23%, outperforming the S&P 500.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Steady Income Potential:</strong> Commuter vehicle rentals generate significant monthly income.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Unique Diversification:</strong> Unique opportunities such as Trucks, RVs and other specialty vehicles offer diversification and revenue.
          </li>
        </ul>
        <div style={{ marginTop: "30px" }}>
          <img src={proof} alt="Proof" style={{ width: "40%", borderRadius: "10px" }} />
        </div>
      </section>

{/* FAQ Section */}
<section 
  style={{
    marginBottom: "100px",
    maxWidth: "800px",
    margin: "auto",
    padding: "20px",
    backgroundColor: "#1e1e1e",
    borderRadius: "10px",
    color: "white"  // All text inside will now be white
  }}
>
  <h2 style={{ fontSize: "36px", textAlign: "center", marginBottom: "20px" }}>
    Frequently Asked Questions
  </h2>
  <details style={{ marginBottom: "10px" }}>
    <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
      What exactly is Gier?
    </summary>
    <p>
    Gier is a tech startup that uses AI to help find and manage vehicle assets for investors. We host a platform for investors to purchase hand-picked rare, limited, or commuter vehicles that have high potential returns. We use AI to help us analyze the market, historical data, health of the vehicle, 
    damage and even predict when the vehicle will break down. You can use our AI Mechanic to help you analyze vehicles that you own or want to purchase.
    </p>

  </details>
  <details style={{ marginBottom: "10px" }}>
    <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
      How do you use AI?
    </summary>
    <p>
      The first use of AI is to help us analyze the vehicle market, historical data, needed repairs, and potential future issues. This gives us a good idea of what the vehicle is worth and helps us pick the best investments. 
      Another use of AI is to help us determine actual cost of damage in real time. This allows rental companies to dispute claims 
      before the customer leaves the lot. Finally we use AI to manage the overall health of the vehicle fleets. Our AI will keep a close eye on all vehicles including damage on the interior and exterior. This includes things like dents, scratches, and even the health of the engine. 
      Using AI we can also try to predict when certain parts will break down.  
      This results in higher returns, lower costs, less downtime, 
      more customization, better service, and  most importantly happier customers.

    </p>
  </details>
  <details style={{ marginBottom: "10px" }}>
    <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
      How does insurance work?
    </summary>
    <p>
      Insurance will be paid for by the rental income of the vehicle. If it is a rare vehicle only for appreciation it will already be added to the listing price.
    </p>
  </details>
  <details style={{ marginBottom: "10px" }}>
    <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
      What about damage?
    </summary>
    <p>
      Damage is actually good. We make money off damage claims and getting the vehicle repaired. Even things such as damage offer a way to extract more value from a vehicle.
    </p>
  </details>
  <details style={{ marginBottom: "10px" }}>
    <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
      Is this crowdfunding?
    </summary>
    <p>
      GIER is not specifically a crowdfunding platform. We plan to have most vehicles already bought and renting before investors have a chance to buy them. If the vehicle is not owned and money is being raised that vehicle at that time is being crowdfunded.
    </p>
  </details>
  <details style={{ marginBottom: "10px" }}>
    <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
      How long is the average investment?
    </summary>
    <p>
      We plan to hold each investment vehicle for 1-3 years. This could be shorter or longer depending on the potential to maximize profits.
    </p>
  </details>
  <details style={{ marginBottom: "10px" }}>
    <summary style={{ fontSize: "1.2rem", cursor: "pointer" }}>
      How do i get started?
    </summary>
    <p>
      Just create an account and head to the marketplace to purchase your first vehicle! It will show up on your profile after and you will start earning revenue!
    </p>
  </details>
</section>


      {/* Explore Marketplace Section */}
      <section style={{ marginBottom: "60px" }}>
        <h2 style={{ fontSize: "36px", textAlign: "center", marginBottom: "20px", color: "#333" }}>
          Explore Our Investment Vehicle Marketplace
        </h2>
        <Carousel autoPlay infiniteLoop showThumbs={false} style={{ maxWidth: "800px", margin: "0 auto" }}>
          {randomVehicles.map(vehicle => (
            <div key={vehicle.id} style={{ textAlign: "center", padding: "10px" }}>
              <img 
                src={vehicle.image} 
                alt={vehicle.title} 
                style={{ width: "500px", height: "auto", marginBottom: "10px", borderRadius: "10px" }} 
              />
              <h3 style={{ fontSize: "1.5rem", color: "#007bff", margin: "10px 0" }}>
                {vehicle.title}
              </h3>
              <p style={{ fontSize: "1.2rem", color: "#333" }}>{vehicle.description}</p>
            </div>
          ))}
        </Carousel>
      </section>

      {/* CTA Section */}
      <section style={{ textAlign: "center", padding: "50px 20px", backgroundColor: "#1e1e1e", color: "white", borderRadius: "10px" }}>
        <h2 style={{ fontSize: "2.5rem", marginBottom: "20px" }}>Ready to Start?</h2>
        <p style={{ fontSize: "1.5rem", marginBottom: "20px" }}>
          Join thousands of investors and start earning today!
        </p>
        <button
          style={{
            padding: "15px 30px",
            fontSize: "1.5rem",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
          onClick={() => {
            window.location.href = "/login";
          }}
        >
          Get Started
        </button>
      </section>
    </div>
  );
};

export default HowItWorksPage;
